import { useEffect, useRef } from 'react'

import { keyType } from '../constants/string'

export function useClickOutside(onClose: () => void, targetRef?: any, isEmptyWebviewData?: any) {
  const ref = useRef(null)

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    ref.current && (ref.current.onkeydown = handleKeyDown)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  })

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target) && onClose && !isEmptyWebviewData ) {
      if (
        targetRef === undefined ||
        !targetRef.current.contains(event.target)
      ) {
        onClose()
      }
    }
  }

  const handleKeyDown = event => {
    const currentKey = event.key.toLowerCase()
    if (currentKey === keyType.ESCAPE) {
      onClose()
    }
  }

  return ref
}
